import React from "react";

interface ErrorIconProps extends React.SVGProps<SVGSVGElement> {}

const ErrorIcon: React.FC<ErrorIconProps> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM8.8 12H7.2V10.4H8.8V12ZM8.8 8.8H7.2V4H8.8V8.8Z"
      fill="#DC2626"
    />
  </svg>
);

export { ErrorIcon };
export default ErrorIcon;
